export const AGE_GATE_STORAGE_KEY = 'fmk_age_gate_verified_v1';
export const AGE_GATE_LEAVE_URL = 'https://www.google.com';
export const AGE_GATE_TERMS_URL = '/terms.html';
export const AGE_GATE_PRIVACY_URL = '/privacy.html';

export const hasAgeGateVerification = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(AGE_GATE_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

export const setAgeGateVerification = (): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(AGE_GATE_STORAGE_KEY, '1');
  } catch {
    // Ignore storage write failures and allow session-only access.
  }
};
